import { AccountTypes, AnyService, RequestedAccounts } from "../../../../types/global";

export default (requestedAccounts: RequestedAccounts) => Object.keys(requestedAccounts).reduce((prev, current) => {
    const requestedServices = Object.keys(requestedAccounts[current as AccountTypes]).filter((s) => requestedAccounts[current as AccountTypes][s as AnyService].requested)
    if (!requestedServices.length) return prev;
    return ({ ...prev, [current]: requestedServices.reduce((sPrev, sCurrent) => ({ ...sPrev, [sCurrent]: requestedAccounts[current as AccountTypes][sCurrent as AnyService] }), {}) })
}, {}) as RequestedAccounts